import { api } from '@/api';

export interface GetDraftDownloadRequest {
  draftVersionId: string;
  citationIndexMap: Record<string, number>;
}

export interface GetDraftDownloadResponse {
  downloadPath: string;
  downloadToken: string;
}

const getDraftDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDraftDownload: builder.mutation<GetDraftDownloadResponse, GetDraftDownloadRequest>({
      query: (body) => ({
        url: '/chat/draft/download-version',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetDraftDownloadMutation } = getDraftDownloadApi;
